import { render, staticRenderFns } from "./LoadingParticipant.vue?vue&type=template&id=48a0a33e&scoped=true&"
import script from "./LoadingParticipant.vue?vue&type=script&lang=js&"
export * from "./LoadingParticipant.vue?vue&type=script&lang=js&"
import style0 from "./LoadingParticipant.vue?vue&type=style&index=0&id=48a0a33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0a33e",
  null
  
)

export default component.exports